// Service worker registration + briefing scheduler with Notification Triggers fallback

const BRIEFING_TAG = "breakitdown-briefing";

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch {
    return null;
  }
}

export function supportsNotificationTriggers() {
  return (
    "serviceWorker" in navigator &&
    "Notification" in window &&
    "showTrigger" in (Notification.prototype || {})
  );
}

// Compute next occurrence of HH:MM in the user's local time (today or tomorrow)
export function nextBriefingTimestamp(hhmm) {
  const [h, m] = (hhmm || "08:00").split(":").map((x) => parseInt(x, 10));
  const now = new Date();
  const next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0, 0);
  if (next.getTime() <= now.getTime()) {
    next.setDate(next.getDate() + 1);
  }
  return next.getTime();
}

export async function scheduleBriefingSW(hhmm, topTasks) {
  if (!("serviceWorker" in navigator)) return false;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg || !reg.active) return false;
  if (Notification.permission !== "granted") return false;

  const body =
    topTasks.length === 0
      ? "Clean slate — add your first task of the day!"
      : topTasks.slice(0, 3).map((t, i) => `${i + 1}. ${t.title}`).join("\n");

  reg.active.postMessage({
    type: "SCHEDULE_BRIEFING",
    timestamp: nextBriefingTimestamp(hhmm),
    title: "Your daily briefing",
    body,
    tag: BRIEFING_TAG,
  });
  return true;
}

export async function cancelBriefingSW() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg || !reg.active) return;
  reg.active.postMessage({ type: "CANCEL_BRIEFINGS", tag: BRIEFING_TAG });
}
